// extracted by mini-css-extract-plugin
export default {"root":"MarketDescriptionTooltip_root--NFB","tooltip":"MarketDescriptionTooltip_tooltip--uLk"};